var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88835 6.875L5.72219 0.375C5.40323 -0.125 4.59832 -0.125 4.27721 0.375L0.112999 6.875C-0.20752 7.37321 0.191693 8 0.834119 8H9.16645C9.80632 8 10.2067 7.375 9.88835 6.875ZM4.53074 2.42857C4.53074 2.19196 4.7407 2 4.9995 2C5.2583 2 5.46827 2.19286 5.46827 2.42857V4.71429C5.46827 4.95089 5.2583 5.14286 5.01708 5.14286C4.77586 5.14286 4.53074 4.95179 4.53074 4.71429V2.42857ZM4.9995 6.85714C4.66043 6.85714 4.38542 6.60571 4.38542 6.29571C4.38542 5.98571 4.66023 5.73429 4.9995 5.73429C5.33877 5.73429 5.61359 5.98571 5.61359 6.29571C5.61281 6.60536 5.33936 6.85714 4.9995 6.85714Z",
    fill: "#F3681A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b9f38c81b2bb14541b275b652caedae9.svg";
export { ForwardRef as ReactComponent };